module.exports = function(video) {
	'use strict'
	video.directive('videoCategoryEditDir',videoCategoryEditDir);
	videoCategoryEditDir.$inject=[];
	function videoCategoryEditDir() {
		return {
			template: require('./partial/video-category-edit.html'),
			controller:'videoCategoryEditController',
			controllerAs:'vmvce',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-category-edit/js/directive/videoCategoryEditDirective.js
// module id = 652
// module chunks = 0